import { CircularProgress, Stack } from '@mui/material';

const Loader = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <CircularProgress size={40} />
    </Stack>
  );
};

export default Loader;
